const constants = {
    AUTH_SOURCE_KEY: 'amplify-react-auth-source',
    APPLE: 'apple',
    GOOGLE: 'google',
    FACEBOOK: 'facebook',
    SIGN_IN_WITH_HOSTEDUI_KEY: 'amplify-react-signin-with-hostedUI'
};

export default constants;
